import { render, staticRenderFns } from "./caseDetail.vue?vue&type=template&id=86cf9e0e&scoped=true"
import script from "./caseDetail.vue?vue&type=script&lang=js"
export * from "./caseDetail.vue?vue&type=script&lang=js"
import style0 from "./caseDetail.vue?vue&type=style&index=0&id=86cf9e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cf9e0e",
  null
  
)

export default component.exports